<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-file-text-o'"></top-line>
      <div class="back-button">
        <el-button @click="goBackWithPagination" icon="el-icon-arrow-left">返回</el-button>
      </div>
     <el-card shadow="hover" style=" margin: 20px 20px;">
      <el-descriptions title="资源请求基本信息" :column="2" border :colon="true" >
        <!-- 基本信息 -->
        <el-descriptions-item label="ID" span="2">{{ detail.id }}</el-descriptions-item>

        <el-descriptions-item label="用户名称">{{ detail.user_name }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ detail.user_id }}</el-descriptions-item>

        <el-descriptions-item label="产品名称">{{ detail.product_name }}</el-descriptions-item>
        <el-descriptions-item label="产品ID">{{ detail.product_id }}</el-descriptions-item>

        <el-descriptions-item label="数量">{{ detail.quantity }}</el-descriptions-item>
        <el-descriptions-item label="价格">{{ detail.price }} {{ priceUnitLabelMap(detail.price_unit) }}</el-descriptions-item>
        <el-descriptions-item label="开始日期">{{ formatDateTime(detail.start_date) }}</el-descriptions-item>
        <el-descriptions-item label="结束日期">{{ formatDateTime(detail.end_date) }}</el-descriptions-item>

        <el-descriptions-item label="状态">
          <el-tag :type="getStatusFormat(detail.status)">
            {{ formatQuestStatusText(detail.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="描述" :span="2">{{ detail.description }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDateTime(detail.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ detail.created_by }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatDateTime(detail.updated_at) }}</el-descriptions-item>
        <el-descriptions-item label="更新人">{{ detail.updated_by }}</el-descriptions-item>
      </el-descriptions>

      <!-- 资源请求用户信息 -->
      <el-descriptions title="资源请求用户信息" :column="2" border :colon="true" style="margin-top: 30px;">
        <el-descriptions-item label="用户姓名">{{ requestUser.username }}</el-descriptions-item>
        <el-descriptions-item label="账号">{{ requestUser.account }}</el-descriptions-item>
        <el-descriptions-item label="工号">{{ requestUser.emp_no }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ requestUser.email }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ requestUser.phone }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ requestUser.gender === '1' ? '男' : requestUser.gender === '0' ? '女' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ requestUser.id }}</el-descriptions-item>
        <el-descriptions-item label="描述">{{ requestUser.description }}</el-descriptions-item>
        <el-descriptions-item label="创建时间" :span="2">{{ requestUser.created_at }}</el-descriptions-item>
      </el-descriptions>

      <el-row style="margin-top: 30px; text-align: center;">
        <el-button @click="goBackWithPagination">返回</el-button>
      </el-row>
    </el-card>

  </d2-container>
</template>


<script>
import topLine from "@/components/save-common/topLine.vue";
import { priceUnitLabelMap, getStatusFormat, formatQuestStatusText } from '@/utils/dataproc'
import util from '@/libs/util.js'

export default {
  name: 'ResourceRequestDetails',
  components: {
    topLine
  },
  data() {
    return {
      pageTitle: "资源请求详情",
      labelWidth: '120px',
      detail: {},
      requestUser: {
        username: '未知用户',
        account: '未知账号',
        emp_no: '-',
        email: '-',
        phone: '-',
        gender: '-',
        id: '-',
        description: '-',
        created_at: '-'
      }
    }
  },
  created() {
    const id = this.$route.query.id;
    if (id) {
      this.fetchDetail(id);
    } else {
      console.error('No id provided');
    }
  },
  methods: {
    getStatusFormat,
    formatQuestStatusText,
    priceUnitLabelMap,

    async fetchDetail(id) {
      try {
        const response = await this.$axios.get(`/api-30216/api/resource-requests/${id}`);
        console.log('资源请求详情响应:', response);
        this.detail = response.data;
        console.log('资源请求详情数据:', this.detail);
        
        // 获取到详情后，使用创建人请求用户信息
        if (this.detail.created_by) {
          console.log('发现创建人:', this.detail.created_by);
          this.fetchRequestUserInfo(this.detail.created_by);
        } else {
          console.log('未发现创建人字段');
        }
      } catch (error) {
        console.error('Failed to fetch resource request details', error);
      }
    },

    async fetchRequestUserInfo(username) {
      try {
        console.log('开始获取资源请求用户信息，用户名:', username);

        // 测试API调用
        console.log('API调用地址:', '/api-30216/api/user/frontend');
        console.log('API调用参数:', { username });

        // 实际API调用
        const response = await this.$axios.get('/api-30216/api/user/frontend', {
          params: { username }
        });

        console.log('用户管理API响应:', response);
        console.log('响应数据:', response.data);
        console.log('响应数据类型:', typeof response.data);
        console.log('响应数据属性:', Object.keys(response.data || {}));

        // 检查响应格式 - 更灵活的检查
        if (response.data) {
          // 检查是否有data字段
          const userData = response.data.data || response.data;
          console.log('用户数据:', userData);
          console.log('用户数据属性:', Object.keys(userData || {}));
          
          if (userData) {
            console.log('用户数据 - id:', userData.id);
            console.log('用户数据 - name:', userData.name);
            console.log('用户数据 - display_name:', userData.display_name);
            console.log('用户数据 - description:', userData.description);
            console.log('用户数据 - phone:', userData.phone);
            console.log('用户数据 - email:', userData.email);
            console.log('用户数据 - created_at:', userData.created_at);
            
            // 确保所有字段都有值
            this.requestUser = {
              username: userData.display_name || userData.name || '未知用户',
              account: userData.name || '-',
              emp_no: '-',
              email: userData.email || '-',
              phone: userData.phone || '-',
              gender: '-',
              id: userData.id || '-',
              description: userData.description || '-',
              created_at: userData.created_at || '-'
            };
            
            console.log('映射后的用户信息:', this.requestUser);
          } else {
            console.error('用户管理API响应无数据');
            this.requestUser = {
              ...this.requestUser,
              username: username,
              account: username
            };
          }
        } else {
          console.error('用户管理API响应格式不正确');
          this.requestUser = {
            ...this.requestUser,
            username: username,
            account: username
          };
        }

        console.log('最终获取的用户信息:', this.requestUser);
      } catch (error) {
        console.error('获取用户信息失败:', error);
        console.error('错误详情:', error.response || error.message);
        this.requestUser = {
          ...this.requestUser,
          username: username,
          account: username
        };
      }
    },

    formatStatus(value) {
      const map = {
        1: '处理中(待销售确认)',
        2: '待交付(销售已确认)',
        3: '已拒绝(放弃)',
        4: '已完成(已交付)',
        5: '已取消(用户取消)',
      };
      return map[value] || '-';
    },

    formatDateTime(datetime) {
      if (!datetime) return '';

      const date = new Date(datetime);
      if (isNaN(date.getTime())) return '';

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    goBackWithPagination() {
      const previousPagePath = '/api/resource-requests';
      const { page, pageSize } = this.$route.query;
      this.$router.push({
        path: previousPagePath,
        query: {
          page: page || 1,
          pageSize: pageSize || 10,
        }
      });
    },
  }
}
</script>
<style scoped>
.back-button {
  margin-left: 20px;
}

</style>
